// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
//import VueSocketio from 'vue-socket.io'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './vuex/store'
// import CKEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue';
import {
	Base64
} from 'js-base64'
import md5 from 'js-md5'

// import baiDuMap from 'vue-baidu-map'

// 引入打印
import Print from './print.js'
Vue.use(Print)

import htmlToPdf from '@/mixin/htmlToPdf.js'
// 使用Vue.use()方法就会调用工具方法中的install方法
Vue.use(htmlToPdf)


import myMix from './mixin'
// import FullCalendar from 'vue-full-calendar' //全局 日历记事本

// Vue.use(FullCalendar)
Vue.use(ElementUI)
Vue.use(CKEditor)
Vue.use(Base64)
// Vue.use(baiDuMap, {
// 	ak: 'QtBEEYAaRW0HjNYMrujucAGegiFVCtWk'
// })

// 设置浏览器标题
Vue.directive('title', {
	inserted: function(el, binding) {
		document.title = el.dataset.title
	}
})


/*Vue.use(new VueSocketio({
    debug: true,
    connection: 'http://localhost:16800' // 地址+端口，由后端提供
}));*/


/** 加载样式文件 */
import '../static/css/mystyle.css' // 引入公共样式(修改elementUI默认样式)
import '../src/view/style.css'

// 引入公共样式(修改elementUI默认样式)
// import '../static/css/components.css'
import '../static/css/navigation.css' // 引入公共样式(自定义样式)
import '../static/css/newForm.css' // 引入公共样式(表单样式)
import '../static/js/iconfont' // 引入阿里iconfont
import echarts from 'echarts';



Vue.prototype.$echarts = echarts;
Vue.prototype.$md5 = md5;
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$store = store
Vue.config.productionTip = false
window.xmlns = 'http://www.w3.org/2000/svg'

Vue.prototype.curVersion = '/api/1.1' // 接口版本号


/****** local dev ******/
Vue.prototype.url = 'http://localhost:9093' // 本地地址
Vue.prototype.domainName = 'http://localhost:9093'

/****** server  ******/
Vue.prototype.url = 'https://mip.lawband.com:9093'
Vue.prototype.domainName = 'https://mip.lawband.com:9093'
/****** end ******/



/****** server  ******/
// Vue.prototype.url = 'http://120.26.163.189:9093'
// Vue.prototype.domainName = 'http://120.26.163.189:9093'
/****** end ******/
/****** server  ******/
// Vue.prototype.url = 'https://mip.lawband.com:9093'
// Vue.prototype.domainName = 'https://mip.lawband.com:9093'
/****** end ******/



/****** server  ******/
// Vue.prototype.url = 'http://120.26.163.45:9093'
// Vue.prototype.domainName = 'http://120.26.163.45:9093'
/****** end ******/



// let url = window.location.href
// url = url.substr(url.indexOf('://') + 3)
// Vue.prototype.domainName = url.substr(0, url.indexOf('/'))


new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js